import { render, staticRenderFns } from "./updatedProduct.vue?vue&type=template&id=ccadccdc&scoped=true"
import script from "./updatedProduct.vue?vue&type=script&lang=js"
export * from "./updatedProduct.vue?vue&type=script&lang=js"
import style0 from "./updatedProduct.vue?vue&type=style&index=0&id=ccadccdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccadccdc",
  null
  
)

export default component.exports